<template>
  <v-card class="position-relative full-width full-height rounded-lg">
    <div
      class="d-flex flex-column position-absolute full-width full-height overflow-hidden"
    >
      <div class="flex-grow-1 position-relative">
        <div
          class="position-absolute full-width full-height d-flex flex-column"
        >
          <slot />
        </div>
      </div>
      <div class="flex-grow-0">
        <v-divider></v-divider>
        <v-card-actions class="">
          <v-menu v-model="menu" absolute offset-y>
            <template v-slot:activator="{ on }">
              <div
                class="d-flex justify-center align-center btn-container full-width"
              >
                <base-button text v-on="on">
                  {{ currentItem.text }}
                </base-button>
              </div>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                @click="handler(item)"
              >
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-actions>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    params: { type: Object, default: () => ({}) },
  },
  data: (vm) => ({
    menu: false,
    items: [
      {
        text: vm.$t('field-select-date.items.3days'),
        value: '3days',
      },
      {
        text: vm.$t('field-select-date.items.7days'),
        value: '7days',
      },
      {
        text: vm.$t('field-select-date.items.30days'),
        value: '1month',
      },
    ],
    currentItem: {
      text: vm.$t('field-select-date.items.7days'),
      value: '7days',
    },
  }),
  computed: {},
  methods: {
    handler(item) {
      if (item) {
        this.currentItem = item
        this.$emit('update:params', { ...this.params, type: item.value })
      }
    },
  },
}
</script>

<style scoped></style>
